import { Component, OnInit } from "@angular/core";

@Component({
  selector: 'about-us-landing',
  templateUrl: './about-us-landing.component.html',
  styleUrls: ['./about-us-landing.component.css']
})
export class AboutUsLandingComponent implements OnInit {

  constructor() {
  }
  ngOnInit() {
   
  }
}

